import {ConnectedDevice, Lifecycle} from "@psdk/frame-father";
import {GenericCPCL} from "./generic";


/**
 * CPCL entrypoint
 */
export class CPCL {

  /**
   * Generic cpcl command
   * @param lifecycle lifecycle
   */
  public static generic(lifecycle: Lifecycle): GenericCPCL {
    return new GenericCPCL(lifecycle);
  }

  // todo: rename to genericWithConnected
  public static genericConnected(connection: ConnectedDevice): GenericCPCL {
    const lifecycle = new Lifecycle(connection);
    return new GenericCPCL(lifecycle);
  }
}
